import React from "react";
import Updated from "@assets/images/icons/shield-tick.svg";
import { useTranslation } from "@helpers/translate";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toggleLoginModal } from "@actions/authModalsActions";
import { MAIN_PAGE } from "../../../constants";

import FormButton from "@components/auth/forms/shared/FormButton";

import "./UpdatedPassword.sass";

export const UpdatedPassword = () => {
  const { __ } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLoginClick = () => {
    dispatch(toggleLoginModal(true));
    navigate(MAIN_PAGE);
  };

  return (
    <div className="updated-password-page">
      <div className="auth-form updated-password">
        <div className="auth-form__form updated-password__content">
          <picture className="updated-password__icon">
            <img src={Updated} alt="shield tick" />
          </picture>

          <h1 className="auth-form__title updated-password__title">
            {__("auth.updated_pass")}
          </h1>

          <p className="auth-form__description updated-password__description">
            {__("auth.updated_pass_t1")} <br />
            {__("auth.updated_pass_t2")}
          </p>

          <FormButton
            variant="secondary"
            type="button"
            className="auth-form__button-wrapper updated-password__button"
            onClick={handleLoginClick}
          >
            {__("auth.log_in")}
          </FormButton>
        </div>
      </div>
    </div>
  );
};

export default UpdatedPassword;
